/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateProductDto = {
    /**
     * Product catalog code (optional). When omitted, the server assigns the next numeric code (compatible with inventory unit-code generation). If provided, must be digits only or ART-<n>.
     */
    code?: string;
    /**
     * Product name
     */
    name: string;
    /**
     * Product description
     */
    description?: string;
    /**
     * Product status
     */
    status: CreateProductDto.status;
    /**
     * Product image path
     */
    imagePath?: string;
    /**
     * Whether a separate S3 thumbnail (_thumb) exists for this imagePath
     */
    hasThumbnail?: boolean;
    /**
     * Category ID
     */
    categoryId?: number;
    /**
     * Material ID
     */
    materialId?: number;
    /**
     * Weight in grams
     */
    weightGrams?: number;
    /**
     * Length in millimeters
     */
    lengthMm?: number;
    /**
     * Talla (almacenado en diameterSize)
     */
    diameterSize?: string;
    /**
     * Properties description
     */
    propertiesDescription?: string;
    /**
     * Product color
     */
    color?: string;
    /**
     * Color ID
     */
    colorId?: number;
    /**
     * Workshop product code
     */
    workshopCode?: string;
    /**
     * Cost price
     */
    costPrice: number;
    /**
     * Sale price
     */
    salePrice: number;
    /**
     * Supplier ID
     */
    supplierId?: number;
    /**
     * Supplier code
     */
    supplierCode?: string;
    /**
     * Created by user ID
     */
    createdBy?: string;
    /**
     * Updated by user ID
     */
    updatedBy?: string;
    /**
     * Tag IDs
     */
    tagIds?: Array<number>;
};
export namespace CreateProductDto {
    /**
     * Product status
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
}

